import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

const ThankYou = () => {
  const [submissionId, setSubmissionId] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    const storedSubmissionId = sessionStorage.getItem('submissionId');
    if (!storedSubmissionId) {
      navigate('/');
      return;
    }
    setSubmissionId(storedSubmissionId);
  }, [navigate]);

  const handleNewSubmission = () => {
    // Clear session storage and start over
    sessionStorage.clear();
    navigate('/');
  };

  return (
    <div className="form-container thank-you-container">
      <div className="icon">✅</div>
      <h2>Submission Complete!</h2>
      <p>
        Your documents have been successfully uploaded to secure storage.
        Please save your submission reference for your records:
      </p>
      {submissionId && (
        <div className="submission-id">
          {submissionId}
        </div>
      )}
      <p>
        Your commitment documentation has been processed and is now available 
        for review. Thank you for participating in the High Point Market program.
      </p>
      
      <div className="button-group">
        <button
          type="button"
          onClick={handleNewSubmission}
          className="btn btn-primary"
        >
          Submit Another Entry
        </button>
      </div>
    </div>
  );
};

export default ThankYou;
